// extracted by mini-css-extract-plugin
module.exports = {"outer_container":"DateOfBirthWrapper_outer_container__1BjID","input_container":"DateOfBirthWrapper_input_container__17TLR","state_logo":"DateOfBirthWrapper_state_logo__29RAx"};